import { PropsWithChildren } from 'react';

import { ChakraFlex, ChakraVStack, Text } from '@equip.health/ui';

import { BILLING_PERIODS_TOP_LEVEL_ID } from '~/lib/constants';

interface BillingPeriodLayoutProps extends PropsWithChildren {
  title: string;
  action?: JSX.Element;
  isHeaderVisible?: boolean;
}

const BillingPeriodLayout = ({
  action,
  children,
  isHeaderVisible,
  title,
}: BillingPeriodLayoutProps) => {
  return (
    <ChakraVStack
      align="flex-stretch"
      gap="24px"
      id={`${BILLING_PERIODS_TOP_LEVEL_ID}__layout`}
      width="100%"
    >
      <ChakraFlex alignItems="center" justify="space-between" width="100%">
        <Text
          color="neutral.primary"
          id={`${BILLING_PERIODS_TOP_LEVEL_ID}__header`}
          variant="h5"
        >
          {title}
        </Text>
        {isHeaderVisible && action}
      </ChakraFlex>
      {children}
    </ChakraVStack>
  );
};

export default BillingPeriodLayout;
